module.exports = __webpack_public_path__ + "static/media/manu-16.20f3ee10.png";